import * as React from 'react';

interface ISidebarProps {
    className?: string;
}
const Sidebar: React.SFC<ISidebarProps> = (props) => {
    return (
        <div className={props.className+" sidebar"} >
            {props.children}
        </div>
    );
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/modules/Routing/Sidebar/Siderbar.tsx